const SET_STATES = (state, payload) => {
  state.states = payload;
}

export default {
  SET_STATES
}